import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { useNavTrail } from '../../Layouts/LayoutMenuData';

const isSame = (a, b) =>
  String(a || '')
    .trim()
    .toLowerCase() ===
  String(b || '')
    .trim()
    .toLowerCase();

// Home > Group > Module > Page, taken from the sidebar so both always agree.
// Without a sidebar match (or on Crude) the caller's pageTitle is used.
const BreadCrumb = ({ title, pageTitle }) => {
  const trail = useNavTrail();
  const group = trail?.group.label;
  const moduleNode = trail?.module;
  const pageLabel = trail?.page?.label;
  const showTitle = !!title && !isSame(title, pageLabel || moduleNode?.label);

  // Each page needs its own document title: it is what a screen reader
  // announces on navigation and what the tab strip / history show.
  useEffect(() => {
    if (typeof title === 'string' && title.trim()) {
      document.title = `${title.trim()} | HYROC`;
    }
  }, [title]);

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div className='page-title-box d-sm-flex align-items-center justify-content-between gap-3'>
            <h1 className='h4 mb-1 mb-sm-0'>{title}</h1>

            <nav className='page-title-right' aria-label='Breadcrumb'>
              <ol className='breadcrumb m-0'>
                <li className='breadcrumb-item'>
                  <Link to='/dashboard' aria-label='Dashboard'>
                    <i
                      className='ri-home-4-line align-middle'
                      aria-hidden='true'
                    ></i>
                  </Link>
                </li>
                {trail ? (
                  <>
                    {group && <li className='breadcrumb-item'>{group}</li>}
                    {moduleNode && (
                      <li
                        className={
                          'breadcrumb-item' +
                          (!pageLabel && !showTitle ? ' active' : '')
                        }
                        aria-current={
                          !pageLabel && !showTitle ? 'page' : undefined
                        }
                      >
                        {pageLabel || showTitle ? (
                          <Link to={moduleNode.link}>{moduleNode.label}</Link>
                        ) : (
                          moduleNode.label
                        )}
                      </li>
                    )}
                    {pageLabel && (
                      <li
                        className={
                          'breadcrumb-item' + (showTitle ? '' : ' active')
                        }
                        aria-current={showTitle ? undefined : 'page'}
                      >
                        {showTitle ? (
                          <Link to={trail.page.link}>{pageLabel}</Link>
                        ) : (
                          pageLabel
                        )}
                      </li>
                    )}
                    {showTitle && (
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'
                      >
                        {title}
                      </li>
                    )}
                  </>
                ) : (
                  <>
                    {pageTitle && (
                      <li className='breadcrumb-item'>
                        <Link to='#'>{pageTitle}</Link>
                      </li>
                    )}
                    <li className='breadcrumb-item active' aria-current='page'>
                      {title}
                    </li>
                  </>
                )}
              </ol>
            </nav>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BreadCrumb;
